import { KeyConstant, SystemConstant } from "const";
import { StorageUtils } from "utils";

export default function useRole() {
  const checkRole = targetRole => Number(StorageUtils.getStoreData(KeyConstant.KEY_ADMIN_ROLE)) === targetRole;

  return {
    isRoot: checkRole(SystemConstant.LOGIN_ROLE.ROOT),
    isAdmin: checkRole(SystemConstant.LOGIN_ROLE.ADMIN),
    isServiceAdmin: checkRole(SystemConstant.LOGIN_ROLE.SERVICE_ADMIN),
  };
}
